var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInactiveFilter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4c-.368 0-.667-.299-.667-.667 0-.368.299-.666.667-.666.368 0 .667.298.667.666C8.667 3.701 8.368 4 8 4zm2-.667c0-1.102-.897-2-2-2s-2 .898-2 2c0 .868.56 1.601 1.333 1.877V14c0 .369.298.667.667.667.369 0 .667-.298.667-.667V5.21C9.44 4.934 10 4.201 10 3.333zM4 12c-.368 0-.667-.299-.667-.667 0-.368.299-.666.667-.666.368 0 .667.298.667.666 0 .368-.299.667-.667.667zm.667-2.543V2c0-.369-.298-.667-.667-.667-.369 0-.667.298-.667.667v7.457C2.56 9.733 2 10.465 2 11.333c0 .868.56 1.601 1.333 1.877V14c0 .369.298.667.667.667.369 0 .667-.298.667-.667v-.79C5.44 12.934 6 12.201 6 11.333c0-.868-.56-1.6-1.333-1.876zM12 9.333c-.368 0-.667-.298-.667-.666 0-.368.299-.667.667-.667.368 0 .667.299.667.667 0 .368-.299.666-.667.666zm2-.666c0-.868-.56-1.601-1.333-1.877V2c0-.369-.298-.667-.667-.667-.369 0-.667.298-.667.667v4.79C10.56 7.066 10 7.799 10 8.667c0 .868.56 1.6 1.333 1.876V14c0 .369.298.667.667.667.369 0 .667-.298.667-.667v-3.457C13.44 10.267 14 9.535 14 8.667z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInactiveFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inactive_filter.d3a413cf.svg";
export { ForwardRef as ReactComponent };